/**
 * Created by prog2 on 25/10/2018.
 */

export default {
    message: {
        title: 'CATEDRAL DE VALÊNCIA',
        preferVisitRead: 'Prefiero leer',
        preferVisitListten: 'Prefiero escuchar',
        downloadAudio: '(Downloading)',
        download:'Descargando',
        errorDownload: 'Error en la descarga.',
        cancelDownload: 'Has cancelado la descarga.',
        initDownload: 'Aguarde enquanto os áudios são descarregados',
        endDownload: 'Os áudios foram descarregados. Desfrute da visita!',
        retry: 'Reintentar',
        noConnection: 'No tienes conexión a internet',
        titleMap: '',
        map: 'Plano1.png',
        menuItems: [
            {
                idImages: 1,
                title: 'Boas-vindas',
                author: 'Por favor, use fones de ouvido',
                description: '',
                // audio: require('./../../assets/audio/ESP/1.mp3')
                audio: '1.mp3'
            },
            {
                idImages: 2,
                title: 'Capela de São Sebastião',
                author: 'Pé da nave',
                description: '',
                audio: '2.mp3'

            },
            {
                idImages: 3,
                title: 'Capela de São Pedro Apóstolo',
                author: 'Nave lateral direita',
                description: '',
                audio: '3.mp3'

            },
            {
                idImages: 4,
                title: 'Capela de São Francisco de Borja',
                author: 'Nave lateral direita',
                description: '',
                audio: '4.mp3'

            },
            {
                idImages: 5,
                title: 'A janela enviesada',
                author: '',
                description: '.',
                audio: '5.mp3'

            },
            {
                idImages: 6,
                title: 'Altar-mor',
                author: 'Capela-mor',
                description: '',
                audio: '6.mp3'

            },
            {
                idImages: 7,
                title: 'Anjos músicos',
                author: 'Capela-mor',
                description: '',
                audio: '7.mp3'

            },
            {
                idImages: 8,
                title: 'Zimbório',
                author: 'Cruzeiro',
                description: '',
                audio: '8.mp3'

            },
            {
                idImages: 9,
                title: 'Porta da Esmola',
                author: 'Braço direito do cruzeiro',
                description: '',
                audio: '9.mp3'

            },
            {
                idImages: 10,
                title: 'Deambulatório + Órgão',
                author: 'Deambulatório',
                description: '',
                audio: '10.mp3'

            },
            {
                idImages: 11,
                title: 'Ressurreição',
                author: 'Capelas do deambulatório',
                description: '',
                audio: '11.mp3'

            },
            {
                idImages: 12,
                title: 'Cristo da Boa Morte',
                author: 'Capelas do deambulatório',
                description: '',
                audio: '12.mp3'

            },
            {
                idImages: 13,
                title: 'Virgem da Cadeira',
                author: 'Capelas do deambulatório',
                description: '',
                audio: '13.mp3'

            },
            {
                idImages: 14,
                title: 'São Dionísio e Santa Margarida ',
                author: 'Capelas do deambulatório',
                description: '',
                audio: '14.mp3'

            },
            {
                idImages: 15,
                title: 'Porta dos Apóstolos ',
                author: 'Braço esquerdo do cruzeiro',
                description: '',
                audio: '15.mp3'

            },
            {
                idImages: 16,
                title: 'Continuação da visita',
                author: 'Nave lateral esquerda',
                description: '',
                audio: '16.mp3'

            },
            {
                idImages: 17,
                title: 'Custódia processional ',
                author: 'Museu: rés-do-chão',
                description: '',
                audio: '17.mp3'

            },
            {
                idImages: 18,
                title: 'Mau ladrão + Adoração ',
                author: 'Museu: rés-do-chão',
                description: '',
                audio: '18.mp3'

            },
            {
                idImages: 19,
                title: 'Maquetas',
                author: 'Museu: segundo andar',
                description: '',
                audio: '19.mp3'

            },
            {
                idImages: 20,
                title: 'Apóstolos',
                author: 'Museu: segundo andar',
                description: '',
                audio: '20.mp3'

            },
            {
                idImages: 21,
                title: 'São Tomé + Dormição',
                author: 'Museu: segundo andar',
                description: '',
                audio: '21.mp3'

            },
            {
                idImages: 22,
                title: 'Relicário',
                author: 'Museu: segundo andar',
                description: '',
                audio: '22.mp3'

            },
            {
                idImages: 23,
                title: 'Injúrias',
                author: 'Museu: segundo andar',
                description: '',
                audio: '23.mp3'

            },
            {
                idImages: 24,
                title: 'Corredor + Arte barroca',
                author: 'Museu: segundo andar',
                description: '',
                audio: '24.mp3'

            },
            {
                idImages: 25,
                title: 'Escavação arqueológica',
                author: 'Museu: cave da catedral',
                description: '',
                audio: '25.mp3'

            },
            {
                idImages: 26,
                title: 'Livros do coro + A Última Ceia',
                author: 'Museu: rés-do-chão',
                description: '',
                audio: '26.mp3'

            },
            {
                idImages: 27,
                title: 'O Santo Cálice',
                author: 'Capela do Santo Cálice',
                description: '',
                audio: '27.mp3'

            },
            {
                idImages: 28,
                title: 'Capela do Santo Cálice',
                author: 'Capela do Santo Cálice',
                description: '',
                audio: '28.mp3'

            },
            {
                idImages: 29,
                title: 'O Micalet',
                author: 'Pé da nave',
                description: '',
                audio: '29.mp3'

            },
            {
                idImages: 30,
                title: 'Créditos',
                isCredits:true,
                author: '',
                description: 'Trama Media para a Catedral de Valência.<br><br>© Catedral de Valência.<br><br>Todos os direitos reservados.<br><br>',
                audio: '',
                idCreditImage: 30,
            },


        ]

    }
};



// WEBPACK FOOTER //
// ./src/data/i18n/portugues.js